import React from 'react';
import { useNavigate } from 'react-router-dom';

export const UnauthorizedPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{ 
            height: '100vh', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            textAlign: 'center',
            padding: '2rem',
            background: 'var(--bg-primary)'
        }}>
            <h1 style={{ fontSize: '4rem', marginBottom: '1rem', color: 'var(--accent-primary)' }}>403</h1>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>Access Denied</h2>
            <p style={{ color: 'var(--text-secondary)', maxWidth: '400px', marginBottom: '2rem' }}>
                You don't have permission to access this page. Please contact your administrator if you believe this is an error.
            </p>
            <button 
                onClick={() => navigate('/')}
                style={{ 
                    padding: '0.75rem 1.5rem', 
                    background: 'var(--accent-primary)', 
                    color: 'white', 
                    borderRadius: '8px',
                    fontWeight: '600'
                }}
            >
                Back to Dashboard
            </button>
        </div>
    );
};
